import React from 'react';
import clsx from 'clsx';
import { useContainerQuery } from '@colonist/ui';
import { AccountInfo } from './AccountInfo/AccountInfo.tsx';
import { ActionButton } from './ActionButton/ActionButton.tsx';
import styles from './LoginProviderAccountCard.module.scss';
const NARROW_MAX_WIDTH = 480;
const query = {
    isNarrow: {
        maxWidth: NARROW_MAX_WIDTH
    }
};
/** Single login provider account card. */ export const LoginProviderAccountCard = ({ account })=>{
    const [{ isNarrow }, containerRef] = useContainerQuery(query);
    const size = isNarrow ? 'sm' : 'md';
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: clsx(styles.card, isNarrow && styles.narrow)
    }, /*#__PURE__*/ React.createElement(AccountInfo, {
        image: account.image,
        title: account.title,
        email: account.email,
        isConnected: account.isConnected,
        size: size
    }), /*#__PURE__*/ React.createElement(ActionButton, {
        isConnected: account.isConnected,
        onConnectClick: account.onConnectClick,
        onDisconnectClick: account.onDisconnectClick,
        size: size
    }));
};
